import React from 'react';
import { Navigate } from 'react-router-dom';

// Every CMS page previously rendered for anyone who hit its URL directly;
// the page then made an API call, got a 401, and the axios interceptor
// bounced the browser to /login via a full reload. That worked but meant
// authenticated pages briefly rendered (with empty/broken state) for
// unauthenticated visitors first. Guard the route instead.
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
